import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './MobileHeader.scss';
import AscendLogoOnly from '../../../assets/icons/AscendLogoOnly.svg?url';

export const MobileHeader: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className={s.strip} data-hook="mobile-header">
      <div className={s.header}>
        <h1 className={s.title} data-hook="header-title">
          {t('mobile.header.title-before-logo')}
          <img src={AscendLogoOnly} alt="Ascend Logo" data-hook="header-logo" />
          {t('mobile.header.title-after-logo')}
        </h1>
      </div>
    </div>
  );
};

export default MobileHeader;
